import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allDocuments: [],
    lectureDocument: [],
    loading: false,
    error: null,
};

const documentSlice = createSlice({
    name: 'document',
    initialState,
    reducers: {
        setAllDocuments: (state, action) => {
            state.allDocuments = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
        setLectureDocument: (state, action) => {
            state.lectureDocument = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllDocuments, setLectureDocument } = documentSlice.actions;

export default documentSlice.reducer;